import { mapState } from 'pinia';
import { useUserStore, usePageStore } from '@/store';
import util from '@/common/util';
import {  setCookieAll } from "../cookieStatus";
import PreferencePop from "./PreferencePop";

const COOKIE_AUTHORITY_KEY = 'cookie_authority_query_v2';  //  0 开启， 1 开启过了

export const isShowCookieAuthority = () => {
    return util.getCookie(COOKIE_AUTHORITY_KEY) != '1';
}

export const setShowCookieAuthority = () => {
    return util.setCookie(COOKIE_AUTHORITY_KEY, '1', 364);
}


export default {
    i18next: {
        ns: 'common'
    },
    data: function() {
        return {
            show: false,
        };
    },
    props: {
        onDestroy: {
            type: Function,
            default() {
                return () => {};
            }
        }
    },
    watch: {
        show(v, oldValue) {
            if (!v && oldValue) {
                setShowCookieAuthority();
                this.destroy();
            }
        },
    },
    computed: {
        ...mapState(usePageStore, ['page']),
        ...mapState(useUserStore, ['user']),
        wordPressSSR({ page }) {
            return page.wordPressSSR;
        },
        description() {
            return this.$t('cookie.desc');
        },
        moreInfo() {
            return this.$t('cookie.more');
        },
        okText() {
            return this.$t('cookie.acceptAll');
        },
        rejectText() {
            return this.$t('cookie.declineAll');
        },
        preferences() {
            return this.$t('cookie.preferences');
        }
    },
    mounted() {
        if (isShowCookieAuthority()) {
            this.setVisible(true);
        }
        this.$EventBus.$on("cookie_setting_has_set", this.setClose);
        // PreferencePop();
    },
    methods: {
        setClose() {
            this.show = false;
            setShowCookieAuthority();
        },
        setVisible(v) {
            this.show = !!v;
        },
        destroy() {
            // 动画执行之后再移除
            setTimeout(() => {
                this.onDestroy();
            }, 1000);
        },
        setCookieAll(flag) {
            setCookieAll(util, flag).then(() => {
                this.setClose();
            });
        },
        onPreferences() {
            PreferencePop();
        }
    },
    destroy() {
        this.$EventBus.$off("cookie_setting_has_set", this.setClose);
    }
};
